import "./ControlCenter.css";
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import Logout from '@mui/icons-material/Logout';
import Settings from '@mui/icons-material/Settings';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import BusinessIcon from '@mui/icons-material/Business';

import Logo from "../../../../src/logo.svg";
import EnIcon from '../../../libraries/Icons/en.png';
import ViIcon from '../../../libraries/Icons/vi.png';
import JaIcon from '../../../libraries/Icons/ja.png';

import {
  Signout,
  ChangeLanguage,
} from "../../../services/Auth.service";

import {
  GetAvatar,
} from '../../../services/Profile.service';

const ControlCenter = (props) => {
  const { translate, UserInfor, Intl, ConfirmDialog } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
  const [openChangeLanguage, setOpenChangeLanguage] = React.useState(false);
  const [anchorElChangeLanguage, setAnchorElChangeLanguage] = React.useState(null);
  const [activeMenu, setActiveMenu] = React.useState();
  const [image, setImage] = React.useState();
  const [expand, setExpand] = React.useState(false);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const menus = [
    {
      name: 'dashboard',
      to: "dashboard",
      icon: <DashboardOutlinedIcon color={activeMenu === 'dashboard' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'documentation',
      to: "documentation/gettingstarted/installation/",
      icon: <ArticleOutlinedIcon color={activeMenu === 'documentation' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'company',
      to: "company",
      icon: <BusinessIcon color={activeMenu === 'company' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'user',
      to: "user",
      icon: <PersonOutlinedIcon color={activeMenu === 'user' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'workspace',
      to: "workspace",
      icon: <PrecisionManufacturingOutlinedIcon color={activeMenu === 'workspace' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'connection',
      to: "connection",
      icon: <LanOutlinedIcon color={activeMenu === 'connection' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'storage',
      to: "storage",
      icon: <FolderOutlinedIcon color={activeMenu === 'storage' ? 'primary' : 'inherit'}/>,
    },
    {
      name: 'schedule',
      to: "schedule",
      icon: <ScheduleOutlinedIcon color={activeMenu === 'schedule' ? 'primary' : 'inherit'}/>,
    },
  ]
  const langs = [
    {
      locale: 'en'
      , src: EnIcon
      , value: 'English'
    },
    {
      locale: 'vi'
      , src: ViIcon
      , value: 'Tiếng Việt'
    },
    {
      locale: 'ja'
      , src: JaIcon
      , value: '日本語'
    },
  ]

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  }

  const handleCloseMobileMenu = () => {
    setOpenMobileMenu(false);
  };

  const handleChangeLanguage = (event) => { 
    setOpenMobileMenu(false);
    setOpenChangeLanguage(true);
    setAnchorElChangeLanguage(event.currentTarget);
  }

  const handleCloseChangeLanguage = () => {
    setOpenChangeLanguage(false);
    setAnchorElChangeLanguage(null);
  };

  const handleSubmitChangeLanguage = (locale) => {
    ChangeLanguage(locale)
    .then(res => {
      localStorage.setItem('_locale', locale);
      props.dispatch({ type: 'UPDATE_INTL', Intl: {locale} });
      handleCloseChangeLanguage();
    })
  }

  const handleClickSignout = () => {
    setAnchorElUser(null);
    props.dispatch({ 
      type: 'UPDATE_CONFIRMDIALOG', 
      ConfirmDialog: {
        open: true,
        title: translate('signout'),
        message: translate('signoutconfirm'),
        buttonName: translate('signout'),
        onClose: () => onCloseConfirmDialog(),
        onAgree: () => onAgreeConfirmDialog()
      } 
    });
  };

  const onCloseConfirmDialog = () => {
    props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
  }

  const onAgreeConfirmDialog = () => {
    Signout();
    props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: {} });
    props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
  }

  useEffect(() => {
    GetAvatar().then(res => setImage(res?.data?.fileName));
  }, [])

  useEffect(() => { 
    if(activeMenu !== location.pathname.split("/")[2]){
      setActiveMenu(location.pathname.split("/")[2]);
      navigate(location);
    }
  },[location]);

  return (
    <Box className="control-center">
      <Box className="menu" sx={{ width: `${expand ? 250 : 85}px` }}>
        <Box component={Link} to="/" sx={{ mt: 0.5, mb: 5 }} className="menu-top">
          <img alt="logo" src={Logo} width={50} className="logo"/>
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/control-center/dashboard"
            color="primary"
            sx={{
              ml: 1,
              mr: 2,
              fontWeight: 700,
              textDecoration: 'none',
              userSelect: 'none',
            }}
          >
            RPA CLOUD
          </Typography>
        </Box>
        <Box className="expand-icon-button" onClick={() => setExpand(!expand)}>
          {expand &&
          <IconButton aria-label="delete" size="small">
            <ChevronLeftIcon fontSize="inherit" />
          </IconButton>}
          {!expand &&
          <IconButton aria-label="delete" size="small">
            <ChevronRightIcon fontSize="inherit" />
          </IconButton>}
        </Box>
        {menus?.filter(element => parseInt(UserInfor.roleID) === 1 ? element : !['company', 'user'].includes(element.name)).map((menu) => (
          <Box className="menu-body" key={menu.name} sx={{ my: 2, display: (!expand ? "contents" : "flex") }} component={Link} to={`/control-center/${menu.to}`}>
            <IconButton color={activeMenu === menu.name ? 'primary' : 'secondary'}>
              {menu.icon}
            </IconButton>
            <Typography
              noWrap
              color="primary"
              sx={{ 
                mx: 1,
                ontWeight: 700,
                textDecoration: 'none',
                userSelect: 'none',
                textAlign: "center",
                color: activeMenu === menu.name ? 'primary.main' : 'secondary.main',
                fontSize: (!expand ? "10px" : "1rem"),
                mb: (!expand ? 2 : 0),

              }}
            >{translate(menu.name)}</Typography>
          </Box>
        ))}
      </Box>
      <Box className="content" sx={{ width: `calc(100% - ${expand ? 250 : 85}px)` }}>
        <AppBar position="sticky" className="app-bar">
          <Container maxWidth="xl" className="top-bar">
            <Toolbar sx={{ justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  noWrap
                  color="primary"
                  sx={{
                    mr: 2,
                    fontWeight: 700,
                    textDecoration: 'none',
                    userSelect: 'none',
                  }}
                >
                  {translate(`${activeMenu}`)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip arrow title={translate('changelanguage')}>
                  <IconButton size="small" onClick={handleChangeLanguage}>
                    <img height="24px" src={
                      Intl.locale === "en" ? EnIcon :
                      Intl.locale === "vi" ? ViIcon :
                      Intl.locale === "ja" ? JaIcon :
                      ""
                    } />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title={translate('opensettings')}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt="" src={image ? `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_DOMAIN_NAME}/tmp/${UserInfor.userID}/profile/avatar/${image}` : ""} sx={{ width: 24, height: 24, bgcolor: "secondary.main" }} />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: '45px' }}
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  <Box className="user-infor-box">
                    <Avatar alt="" src={image ? `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_DOMAIN_NAME}/tmp/${UserInfor.userID}/profile/avatar/${image}` : ""} sx={{ width: 30, height: 30, bgcolor: "secondary.main" }} />
                    <Box>
                      <div className="user-infor-fullname">{`${UserInfor?.firstName} ${UserInfor.lastName}`}</div>
                      <div className="user-infor-email">{UserInfor?.email}</div>
                    </Box>
                  </Box>
                  <Divider />
                  <MenuItem className="user-infor-list" component={Link} to="/control-center/profile" onClick={handleCloseUserMenu} divider>
                    <Settings fontSize="small" color="primary" />
                    <Button textAlign="center">{translate('profile')}</Button>
                  </MenuItem>
                  <MenuItem className="user-infor-list" onClick={handleClickSignout}>
                    <Logout fontSize="small" color="primary" />
                    <Button textAlign="center">{translate('signout')}</Button>
                  </MenuItem>
                </Menu>
              </Box>
              <Dialog
                fullScreen
                open={openMobileMenu}
                onClose={handleCloseMobileMenu}
                TransitionComponent={Transition}
                sx={{ position: (openMobileMenu ? 'fixed' : 'inherit') }}
              >
                <Container maxWidth="xl">
                  <Box sx={{ mt: 1, display: "flex", justifyContent: "right" }}>
                    <button 
                      className="icon-button"
                      onClick={handleCloseMobileMenu}
                    >
                      <CloseIcon size="small" color="primary"/>
                    </button>
                  </Box>
                  <Box>
                    <Box sx={{ my: 1, display: "flex", justifyContent: "left" }}>
                    </Box>
                  </Box>
                </Container>
              </Dialog>
              <Popover
                open={openChangeLanguage}
                anchorEl={anchorElChangeLanguage}
                onClose={handleCloseChangeLanguage}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Box p={1}>
                  <List dense>
                    {langs.map(lang => (
                      <ListItem 
                        button 
                        selected={Intl.locale === lang.locale}
                        onClick={() => {handleSubmitChangeLanguage(lang.locale)}}
                      >
                        <ListItemIcon className='iconChangeLanguage'>
                          <img 
                            height="24px"
                            src={lang.src}
                          />
                        </ListItemIcon>
                        <ListItemText primary={lang.value} className='textChangeLanguage' />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Popover>
            </Toolbar>
          </Container>
        </AppBar>
        <Outlet />
      </Box>
    </Box>
  );
};

function mapStateToProps(state) {
  return {
    UserInfor: state.UserInfor,
    Intl: state.Intl,
    ConfirmDialog: state.ConfirmDialog,
  }
}

export default connect(mapStateToProps)(withTranslate(ControlCenter));